export default "__VITE_ASSET__CSE9AqmU__"